import {
    OnInit,
    OnDestroy,
    Directive,
    SkipSelf,
    Optional,
    Attribute,
    Injector,
    Input
} from '@angular/core';
import {NgForm, AbstractControl, FormGroup, FormArray} from '@angular/forms';
import { CustomNgForm } from "sharedFeatures/@types/customNgForm";

const resolvedPromise = Promise.resolve(null);

@Directive({
    selector: '[nestableForm]'
})
export class NestableFormDirective implements OnInit, OnDestroy {


    private static readonly FORM_ARRAY_NAME = 'CHILD_FORMS';

    private currentForm: FormGroup<{[key: string]: AbstractControl<object | string>}> | undefined;


    @Input()
    private formGroup: FormGroup<{[key: string]: AbstractControl<object | string>}> | undefined;

    // Ivy raises error "No value provided for @angular/core symbol 'ɵɵinjectAttribute'" with @Attribute decorator
    // Attribute "rootNestableForm" is not used, just set it to null
    private isRoot = null;
    constructor( @SkipSelf()
                 @Optional()
                 private parentForm: NestableFormDirective,
                 private injector: Injector //,
                 /*@Attribute('rootNestableForm') private isRoot*/) {
    }

    ngOnInit() {
        if (!this.currentForm) {
            // NOTE: at this point both NgForm and ReactiveFrom should be available
            this.executePostponed(() => this.resolveAndRegister());
        }

    }

    ngOnDestroy() {
        this.executePostponed(() => { if (this.parentForm) this.parentForm.removeControl(this.currentForm as AbstractControl) });
    }

    public registerNestedForm(control: AbstractControl): void {
        // NOTE: prevent circular reference (adding to itself)
        if (control === this.currentForm) {
            throw new Error('Trying to add itself! Nestable form can be added only on parent "NgForm" or "FormGroup".');
        }
        if (this.currentForm)
            (<FormArray<AbstractControl<object | string>>>this.currentForm.get(NestableFormDirective.FORM_ARRAY_NAME)).push(control);
    }

    public removeControl(control: AbstractControl): void {
        if (!this.currentForm)
            return;
        const array = (<FormArray<AbstractControl<object | string>>>this.currentForm.get(NestableFormDirective.FORM_ARRAY_NAME));
        const idx = array.controls.indexOf(control);
        array.removeAt(idx);
    }

    private resolveAndRegister(): void {
        this.currentForm = this.resolveCurrentForm();
        this.currentForm.addControl(NestableFormDirective.FORM_ARRAY_NAME, new FormArray<AbstractControl<object | string>>([]));
        this.registerToParent();
    }

    private resolveCurrentForm(): FormGroup<{[key: string]: AbstractControl<object | string>;}> {

        (this.injector.get(NgForm ) as CustomNgForm).nestableFormDirective = this;

        // NOTE: template-driven or model-driven => determine by the formGroup input
        return this.formGroup ? this.formGroup : this.injector.get(NgForm).control;
    }

    private registerToParent(): void {
        if (this.parentForm != null && !this.isRoot) {
            this.parentForm.registerNestedForm(this.currentForm as AbstractControl);
        }
    }

    private executePostponed(callback: () => void): void {
        resolvedPromise.then(() => callback());
    }

    public static getFormArrayName(): string {

        return NestableFormDirective.FORM_ARRAY_NAME;

    }

}
